module.exports = __webpack_public_path__ + "img/alarm.737f89c0.png";